import { Input as InputForm } from "@/components/Input";
import { Button, Flex, Img, Text, useBoolean, useToast } from "@chakra-ui/react";
import { FormEventHandler, useState } from "react";

import { useAuth } from "@/contexts";
import { useChangePassword } from "@/hooks/Client";
import { useClient } from "@/hooks/Client/useClient";

type Inputs = {
  currulyPassword: string;
  passwordNew: string;
  passwordAgain: string;
};

export function FormNewPassword() {
  const Auth = useAuth();

  const [ClientData, ClientError, ClientLloading] = useClient(Auth.clientId);

  const toast = useToast({
    position: "bottom",
    duration: 4000,
    isClosable: true,
    status: "error"
  });

  const [password, setPassword] = useState(String);
  const [newPassword, setNewPassword] = useState(String);
  const [againPassword, setAgainPassword] = useState(String);
  const [ShowPassword, setShow] = useBoolean();

  const [result, setResult] = useState("");
  const [itsInvalid, setInvalid] = useState(false);

  const onSubmit: FormEventHandler = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    switch (true) {
      case newPassword.length === 0 || againPassword.length === 0 || password.length === 0:
        toast({
          title: "Preencha todos os camposs",
          description: "Todos são obrigatórios!"
        });
        return;
      case newPassword.length < 6:
        toast({
          title: "Senha muito curta",
          description: "A senha deve ter no mínimo 6 caracteres"
        });
        return;
      case newPassword !== againPassword:
        toast({
          title: "Senhas não conferem",
          description: "A nova senha e a confirmação não são iguais"
        });
        return;
    }

    const [PasswordResult, PasswordError, PasswordLoading] = await useChangePassword({
      password,
      newPassword,
      email: ClientData.email,
      clientId: Auth.clientId
    });

    if (PasswordError) {
      toast({
        title: "Erro ao trocar a senha",
        description: PasswordError.message
      });
      return;
    }

    if (PasswordResult && PasswordError === null) {
      if (PasswordResult.status) {
        toast({
          status: "success",
          title: "Senha alterada com sucesso",
          description: "Você pode fazer login com a nova senha"
        });
        return;
      } else {
        toast({
          status: "error",
          title: "Erro ao trocar a senha",
          description: PasswordResult.msgs[0]
        });
        return;
      }
    }

    return;
  };

  return (
    <Flex as="form" direction="column" width={["100%", "45%"]} pt="20px" onSubmit={onSubmit}>
      <Text mb={"5px"} fontSize={"h3"} fontWeight={"600"} color={"ll-blue.main"}>
        Dados de acesso
      </Text>
      <Flex
        flexDir={"column"}
        w={"full"}
        borderTop={"1px dashed"}
        pt={"20px"}
        borderColor={"ll-gray.200"}
        mb={"15px"}
      >
        <Flex width="100%" mb="15px" bgColor={"ll-gray.600"} borderRadius={"50px"}>
          <InputForm
            borderRadius={"50px"}
            bgColor={"white"}
            borderColor={"ll-gray.600"}
            height={"40px"}
            color={"ll-gray.300"}
            label="SENHA ATUAL"
            type={ShowPassword ? "text" : "password"}
            as="input"
            name="passwordOld"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <Button
            onClick={setShow.toggle}
            w={["70px", "60px"]}
            ml={["-5px", "-5px"]}
            mt={["0px", "-0.5px"]}
            h={"40px"}
            background={"transparent"}
          >
            <Img
              src={
                ShowPassword
                  ? "https://cdn.pneufree.com.br/LINGLONG/images/Geral/eye.svg"
                  : "https://cdn.pneufree.com.br/LINGLONG/images/Geral/eye-not.svg"
              }
            />
          </Button>
        </Flex>

        <Flex width="100%" mb="15px" bgColor={"ll-gray.600"} borderRadius={"50px"}>
          <InputForm
            borderRadius={"50px"}
            bgColor={"white"}
            borderColor={"ll-gray.600"}
            height={"40px"}
            color={"ll-gray.300"}
            label="NOVA SENHA"
            type={ShowPassword ? "text" : "password"}
            as="input"
            name="passwordNew"
            isInvalid={itsInvalid}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
          <Button
            onClick={setShow.toggle}
            w={["70px", "60px"]}
            ml={["-5px", "-5px"]}
            mt={["0px", "-0.5px"]}
            h={"40px"}
            background={"transparent"}
          >
            <Img
              src={
                ShowPassword
                  ? "https://cdn.pneufree.com.br/LINGLONG/images/Geral/eye.svg"
                  : "https://cdn.pneufree.com.br/LINGLONG/images/Geral/eye-not.svg"
              }
            />
          </Button>
        </Flex>

        <Flex width="100%" mb="15px" bgColor={"ll-gray.600"} borderRadius={"50px"}>
          <InputForm
            borderRadius={"50px"}
            bgColor={"white"}
            borderColor={"ll-gray.600"}
            height={"40px"}
            color={"ll-gray.300"}
            label="CONFIRME A SENHA"
            type={ShowPassword ? "text" : "password"}
            as="input"
            name="passwordAgain"
            isInvalid={itsInvalid}
            value={againPassword}
            onChange={(e) => setAgainPassword(e.target.value)}
          />
          <Button
            onClick={setShow.toggle}
            w={["70px", "60px"]}
            ml={["-5px", "-5px"]}
            mt={["0px", "-0.5px"]}
            h={"40px"}
            background={"transparent"}
          >
            <Img
              src={
                ShowPassword
                  ? "https://cdn.pneufree.com.br/LINGLONG/images/Geral/eye.svg"
                  : "https://cdn.pneufree.com.br/LINGLONG/images/Geral/eye-not.svg"
              }
            />
          </Button>
        </Flex>
      </Flex>

      <Button variant={"secondary-button"} h={"40px"} _hover={{ opacity: "0.5" }} type="submit">
        EDITAR
      </Button>
    </Flex>
  );
}
